import { useNavigate, useParams } from 'react-router-dom';
import QuotationHistoryLayout from './QuotationHistoryLayout';
import FileHandler from '../List/components/FileHandler';

type Params = {
  id: string;
};

const QuotationHistoryPage = (): JSX.Element => {
  const history = useNavigate();
  const { id } = useParams<Params>();

  function goToDashboard(): void {
    history('/');
  }

  return (
    <>
      <FileHandler />
      <QuotationHistoryLayout
        data-testid="quotation-history-layout-component"
        quotationHash={id as string}
        onCloseClicked={goToDashboard}
      />
    </>
  );
};

export default QuotationHistoryPage;
